import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ButtonTextLoadingAnimation } from "../animation/ButtonLoadingAnimation";
import { GreenButton } from "../button";
import { CustomTextInput } from "../inputs";
import { useSnackbar } from "../toast/showToastMessage";
import { ModalWithButtons } from "./modal";

interface Props {
	open: boolean;
	setOpen: React.Dispatch<React.SetStateAction<boolean>>;

	isEdit: boolean;

	handleSubmit: (newFileName: string) => void;
}

export default function CreateSpecFileWithoutUploadModal(props: Props) {
	const { t: translation } = useTranslation();
	const { openSnackbar } = useSnackbar();

	const { open, setOpen, isEdit, handleSubmit } = props;

	const [loading, setLoading] = useState<boolean>(false);

	const [newFileName, setNewFileName] = useState<string>("");

	useEffect(() => {
		if (open) {
			setNewFileName("");
		}
	}, [open]);

	const addSpecFileModalContent: React.ReactNode = (
		<div className="registration-input-content">
			<CustomTextInput
				id={"spec-folder-name"}
				value={newFileName}
				setValue={setNewFileName}
				label={translation("SpecificationName")}
				type={"text"}
				required
			></CustomTextInput>
		</div>
	);
	const addSpecFileModal: React.ReactNode = (
		<ModalWithButtons
			modalWidth={500}
			headerText={isEdit ? translation("Edit") : translation("Create")}
			open={open}
			setOpen={setOpen}
			buttons={[
				<GreenButton
					key="submit-create-folder-button"
					id="submit-create-folder-button"
					children={
						loading ? (
							<ButtonTextLoadingAnimation
								text={translation("Loading")}
							></ButtonTextLoadingAnimation>
						) : (
							translation("Create")
						)
					}
					onClick={() => handleSubmit(newFileName)}
					disabled={loading}
				></GreenButton>,
			]}
		>
			{addSpecFileModalContent}
		</ModalWithButtons>
	);
	return addSpecFileModal;
}
